/**
 * Class description
 *
 * Created: 2019-08-30
 * @author jonas
 */
import {Timeline, TimelineLite} from "gsap";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SpacierArcadeParsedGameData} from "../server/data/SpacierArcadeParsedGameData";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {SpacierArcadeGameModuleConfig} from "../SpacierArcadeGameModuleConfig";
import {SpacierArcadeParsedInitData} from "../server/data/SpacierArcadeParsedInitData";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {SpacierArcadeGameMode} from "../gamemode/SpacierArcadeGameMode";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {SAFreespinEvent} from "../background/SABackground";

export class GameRestoreHandling implements GameRoundPresentation {
    private _freespinsLeft:number;
    constructor() {
    }

    public prepare(data:SpacierArcadeParsedGameData):void {
        this._freespinsLeft = data.freespinsLeft;
    }

    public getAnimation(data:SpacierArcadeParsedInitData):Timeline | null {
        let tl:TimelineLite = new TimelineLite();
        if(data.isRestoreState) {
            if(data.mode === SpacierArcadeGameMode.FREESPIN_RESPIN || data.mode === SpacierArcadeGameMode.FREESPIN){
                tl.add(() => {
                    EventHandler.dispatchEvent(new GameEvent(SAFreespinEvent.UPDATE_FREE_SPIN_COUNT, data.freespinsLeft));
                    SlotGame.keypad.setZeroBetSpinCounter(data.freespinsLeft);
                });
            }
            tl = SpacierArcadeGameModuleConfig.spacierArcadeOverlayView.getNewStickySymbols(data.overlaySymbols, data.overlayWildsMultipliers, data.spinIntensity, true);
        }
        return tl;
    }

}